/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nativelanguage1Inputs */

const en__field_nativelanguage1 = /** @type {(inputs: _Field_Nativelanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Language`)
};

const de__field_nativelanguage1 = /** @type {(inputs: _Field_Nativelanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muttersprache`)
};

/**
* | output |
* | --- |
* | "Native Language" |
*
* @param {_Field_Nativelanguage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_nativelanguage1 = /** @type {((inputs?: _Field_Nativelanguage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nativelanguage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nativelanguage1(inputs)
	return de__field_nativelanguage1(inputs)
});
export { _field_nativelanguage1 as "_field_nativeLanguage" }